import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  useScreenClass,
  Col,
  Hidden,
  Visible
} from 'components/Grid';

import {
  Container,
  Row,
  Icon,
  Name,
  Description
} from './styles';

const Benefit = ({ name }) => {
  const { t } = useTranslation();
  const screenClass = useScreenClass();

  return (
    <Container>
      <Row screen={screenClass} gutterWidth={20}>
        <Col xs={4} sm={12} align="center">
          <Icon src={`/assets/icons/benefits/${name.toLowerCase()}.svg`} />
        </Col>
        <Col xs={8} sm={12} align={screenClass !== 'xs' ? 'center' : 'left'}>
          <Hidden xs>
            <Name>{t(`BENEFITS.${name}.NAME`)}</Name>
            <Description>{t(`BENEFITS.${name}.DESCRIPTION`)}</Description>
          </Hidden>
          <Visible xs>
            <Name.xs>{t(`BENEFITS.${name}.NAME`)}</Name.xs>
            <Description.xs>{t(`BENEFITS.${name}.DESCRIPTION`)}</Description.xs>
          </Visible>
        </Col>
      </Row>
    </Container>
  );
};

Benefit.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Benefit;
